import React, { FC, useContext } from 'react';

import { SchedulingSectionContext } from './context';
import { SchedulingSectionsMainBlock } from './SchedulingSectionsMainBlock';

export const SectionMainBlockWithContext: FC = () => {
	const { config } = useContext(SchedulingSectionContext);
	const { active } = config || {};
	return active && <SchedulingSectionsMainBlock />;
};
